module.exports = __webpack_public_path__ + "fonts/BebasKai.cbee90cb.otf";